var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("form", [
      _c("div", { staticClass: "dashboard-page-title" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("h1", [_vm._v("Profile Image")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-info",
              attrs: { "active-class": "" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-chevron-left" }),
              _vm._v(" Back\n        "),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "dashboard-block" }, [
          _c("h2", [_vm._v("Profile Picture")]),
          _vm._v(" "),
          _c("div", { staticClass: "panel panel-default" }, [
            _c("div", { staticClass: "panel-body" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("div", { staticClass: "form-horizontal" }, [
                    _c(
                      "div",
                      {
                        class: ["form-group", _vm.errorClass("profile_image")],
                      },
                      [
                        _c("label", { staticClass: "control-label col-sm-4" }, [
                          _vm._v("Upload Image"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-8" },
                          [
                            _c("div", { staticClass: "file-upload-control" }, [
                              _c("input", {
                                attrs: {
                                  name: "profile_image",
                                  id: "profile_image",
                                  type: "file",
                                },
                                on: {
                                  change: _vm.handleFileSelectionCallback,
                                  input: _vm.handleFileSelectionCallback,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "btn btn-default btn-block",
                                  attrs: { for: "profile_image" },
                                },
                                [_vm._v("Select Profile Picture")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "help-block" }, [
                              _vm._v(
                                "For best results images should be 512px by 512px."
                              ),
                            ]),
                            _vm._v(" "),
                            _c("help-block", {
                              attrs: { field: "profile_image" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("div", { staticStyle: { width: "100%" } }, [
                    _c("img", {
                      attrs: {
                        id: "profile-image-crop",
                        src: _vm.userProfileImageOriginalUrl,
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "panel-footer" },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "submit",
                      click: _vm.handleSaveProfileImageCallback,
                      disabled: _vm.userIsAdmin && !_vm.canEditAdmin,
                    },
                  },
                  [_vm._v("\n              Save Profile Picture\n            ")]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }